<template>
  <div>
    <div style="max-height: 400px;overflow-y: auto">
      <el-table :data="showTable" border style="width: 100%;font-size: 16px" highlight-current-row
                :header-cell-style="getBackgroundColor" size="small">
        <el-table-column
          type="index"
          label="序号"
          width="55"
          align="center">
        </el-table-column>
        <el-table-column
          label="事件类型"
          min-width="75"
          align="center">
          <template slot-scope="scope">
            <span>{{getAType(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="time"
          label="事件时间"
          min-width="140"
          align="center">
        </el-table-column>
        <el-table-column
          prop="o_name"
          label="所属组织"
          min-width="75"
          align="center">
        </el-table-column>
        <el-table-column
          prop="p_name"
          label="服务对象"
          min-width="75"
          align="center">
        </el-table-column>
        <el-table-column
          label="设备编号"
          min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.device.deviceid}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="设备类型"
          min-width="140"
          align="center">
          <template slot-scope="scope">
            <img v-if="scope.row.devicetype !== ''" style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImg(scope.row)">
            <span v-if="scope.row.devicetype !== ''">{{getDeviceType(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="设备号码"
          min-width="90">
          <template slot-scope="scope">
            <span>{{scope.row.device.simcardno}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="h_install_location"
          label="安装位置"
          min-width="75"
          align="center">
        </el-table-column>
        <el-table-column
          label="处理情况"
          min-width="75"
          align="center">
          <template slot-scope="scope">
            <span :style="scope.row.ishandle === 0 ? 'color: blue' : ''">{{getIsHandle(scope.row)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="!isFive" style="margin-top: 10px;margin-bottom:10px;text-align: center">
      <el-pagination v-fixZoom
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCells">
      </el-pagination>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import {queryalarmbypids} from '../../../../api/alarmservice'
import {querydevicebydids} from '../../../../api/device'
// import {queryalarmhandle} from '../../../../api/handlealarm'

export default {
  name: 'historyLog',
  props: {
    logObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isFive: false,
      loading: false,
      imgIcon: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      showTable: [],
      tableData: [],
      pids: [],

      dids: [],
      sendDids: [],
      devices: [],
      isSendDevice: true,
      aids: [],
      sendAids: [],
      alarmhandle: [],
      isSendAlarm: true
    }
  },
  created () {
    /* 1、quickopen.vue 快捷弹窗 服务日志  2、dohandleAlarm.vue 处理报警弹窗 服务日志 */
    this.pids = this.logObj.personids
    // console.log(111222, this.pids)
    this.isFive = this.logObj.isFive
    if (this.isFive) {
      this.pageSize = 5
    }
    if (this.pids.length > 0) {
      this.getAlarmLog()
    }
    this.imgIcon = this.getImgArr.getImgIconDevice()
  },
  methods: {
    getBackgroundColor () {
      return {backgroundColor: '#3D83F3', color: '#ffffff', borderColor: '#3D83F3'}
    },
    // 表格信息
    getAlarmLog () {
      let data = {
        pid: this.pids
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryalarmbypids(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.alarms
        let oldDids = this.dids.length
        this.sendDids = []
        let oldAids = this.aids.length
        this.sendAids = []
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.dids.indexOf(this.tableData[i].did) === -1) {
            this.dids.push(this.tableData[i].did)
            this.sendDids.push(this.tableData[i].did)
          }
          if (this.aids.indexOf(this.tableData[i].id) === -1) {
            this.aids.push(this.tableData[i].id)
            this.sendAids.push(this.tableData[i].id)
          }
        }
        if (oldDids === this.dids.length) {
          this.isSendDevice = false
        } else {
          this.isSendDevice = true
        }
        if (oldAids === this.aids.length) {
          this.isSendAlarm = false
        } else {
          this.isSendAlarm = true
        }
        this.getDevices()
      }).catch(() => {})
    },
    // 获取设备
    getDevices () {
      if (this.isSendDevice) {
        let data = {
          dids: this.sendDids
        }
        querydevicebydids(data).then(res => {
          this.devices = this.devices.concat(res.data.devices)
          // console.log(this.devices)
          this.getAlarms()
        }).catch(() => {
        })
      } else {
        this.getAlarms()
      }
    },
    // 派单信息
    getAlarms () { // 弃派单情况
      // if (this.isSendAlarm) {
      //   let data = {
      //     aids: this.sendAids
      //   }
      //   queryalarmhandle(data).then(res => {
      //     this.alarmhandle = this.alarmhandle.concat(res.data.alarmhandle)
      //     this.getEndTable()
      //   }).catch(() => {})
      // } else {
      //   this.getEndTable()
      // }
      this.getEndTable()
    },
    getEndTable () {
      const tempList = this.tableData
      this.tableData = []
      for (let i = 0; i < tempList.length; i++) {
        let device = null
        for (let j = 0; j < this.devices.length; j++) {
          if (tempList[i].did === this.devices[j].id) {
            device = this.devices[j]
          }
        }
        tempList[i].device = device
      }
      this.showTable = tempList
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getAlarmLog()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getAlarmLog()
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getTypeImg (row) {
      let type = ''
      if (row.device) {
        type = row.device.devicetype
      }
      let url = this.imgIcon[0].imgUrl
      for (let i = 0; i < this.imgIcon.length; i++) {
        if (type === this.imgIcon[i].dtype) {
          url = this.imgIcon[i].imgUrl
        }
      }
      return url
    },
    getDeviceType (row) {
      let type = ''
      if (row.device) {
        type = row.device.devicetype
      }
      return this.commonType.getDeviceType(type)
    },
    getIsHandle (row) {
      let handle = ''
      if (row.ishandle === 1) {
        handle = '已处理'
      } else if (row.ishandle === 0) {
        handle = '未处理'
      }
      return handle
    },
    getOrderName (aid) {
      let name = ''
      for (let i = 0; i < this.alarmhandle.length; i++) {
        if (aid === this.alarmhandle[i].aid) {
          if (this.alarmhandle[i].is_dispatch === 0) {
            name = '服务商未处理'
          } else if (this.alarmhandle[i].is_dispatch === 1) {
            name = '服务商已接单'
          } else if (this.alarmhandle[i].is_dispatch === 2) {
            name = '服务商已拒接'
          }
        }
      }
      return name
    },
    getAType (row) {
      return this.commonType.getAlarmType(row.alarmtype)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/quick/components/historyLog.vue